<template>
    <div class="agent-picker">
        <div class="pr-search">
            <input :placeholder="$t('message.searchRepresentative')" v-model="searchText" @input="searchChange" />
            <span class="material-icons mx-2 pr-icon"> search </span>
        </div>
        <hr />
        <div class="pr-items pr-item-wrapper">
            <div class="pr-item" v-for="item of getFilteredItems()" @click="(e) => toggleItem(e, item.value)">
                <a-checkbox
                    v-if="!single"
                    class="segment-checkbox"
                    @click="(e) => toggleItem(e, item.value)"
                    :checked="isExists(item.value)"
                />
                <a-radio
                    v-else
                    class="segment-radio"
                    @click="(e) => toggleItem(e, item.value)"
                    :checked="isExists(item.value)"
                />

                <div class="user-data-wrapper">
                    <div class="user-data">
                        <Avatar :size="30" :src="item.gravatar" :username="item.name" class="mr-2 avatar" />
                        <div class="metas">
                            <div class="pr-item-name">{{ item.name }}</div>
                            <div>
                                {{ getUserDepartmentNames(item) }}
                            </div>
                        </div>
                    </div>

                    <div
                        class="pr-item-status"
                        :data-online="$_.get(user, '_id') === item.value ? true : item.isOnline"
                        :data-status="item.status.toLowerCase()"
                        v-if="item.status"
                    >
                        <div class="pr-item-status-circle"></div>
                        {{ item.status }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import { mapGetters, mapState } from "vuex";
import _ from "lodash";
import Avatar from "vue-avatar";
import log2 from "../../utils/log2";

const log = log2("AgentPicker");
export default Vue.extend({
    name: "AgentPicker",
    components: {
        Avatar,
    },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        omitItems: {
            type: Array,
            default: () => [],
        },
        single: {
            type: Boolean,
            default: false,
        },
        addUnOwned: {
            type: Boolean,
            default: false,
        },
        addNone: {
            type: Boolean,
            default: false,
        },
        addChatbot: {
            type: Boolean,
            default: false,
        },
        addAPI: {
            type: Boolean,
            default: false,
        },
        addBroadcast: {
            type: Boolean,
            default: false,
        },
        addAutomation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            searchText: "",
            selectedItems: _.cloneDeep(this.value || []),
        };
    },
    computed: {
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
        }),
        ...mapState({
            users: (state) => state.user.users.data,
            user: (state) => state.auth.user,
            subjects: (state) => state.subject.subjects.data,
            site: (state) => state.site.site,
        }),
    },

    methods: {
        getItems() {
            let items = _.cloneDeep(this.users).map((x) => ({
                type: "agent",
                value: x._id,
                name: x.name || x.email,
                gravatar: x.gravatar || x.avatar,
                status: x.status || "offline",
                subjects: x.subjects,
            }));

            if (this.addUnOwned) {
                items.unshift({
                    type: "unowned",
                    value: "unowned",
                    name: "Sahipsizler",
                });
            }

            if (this.addNone) {
                items.unshift({
                    type: "none",
                    value: "none",
                    name: "Hiçkimse / Etkileşim Yok",
                });
            }
            if (this.addChatbot) {
                items.unshift({
                    type: "chatbot",
                    value: "chatbot",
                    name: "Chatbot",
                });
            }
            if (this.addAPI) {
                items.unshift({
                    type: "api",
                    value: "api",
                    name: "API",
                });
            }
            if (this.addBroadcast) {
                items.unshift({
                    type: "broadcast",
                    value: "broadcast",
                    name: "Broadcast",
                });
            }
            if (this.addAutomation) {
                items.unshift({
                    type: "automation",
                    value: "automation",
                    name: "Automation",
                });
            }

            return items.filter((x) => !this.omitItems.includes(x.value));
        },
        getUserDepartmentNames(user) {
            if (user.type !== "agent") return "";

            return (user.subjects || []).length
                ? this.subjects
                      .filter((x) => (user.subjects || []).includes(x._id))
                      .map(
                          (x) =>
                              _.get(x, `languageContent.${this.$i18n.locale}.name`) ||
                              _.get(x, `languageContent.${Object.keys(x.languageContent)[0]}.name`)
                      )
                      .join(",")
                      .toLowerCase()
                : this.$t("message.allDepartments");
        },
        isExists(itemId) {
            return !!this.selectedItems.find((x) => x.value === itemId);
        },
        getItemById(itemId) {
            return this.getItems().find((x) => x.value === itemId);
        },
        toggleItem(event, itemId) {
            event.stopPropagation();

            const item = this.getItemById(itemId);
            if (this.single) {
                this.selectedItems = [{ type: item.type, value: item.value }];
            } else {
                this.selectedItems = this.isExists(itemId)
                    ? this.selectedItems.filter((x) => x.value !== itemId)
                    : [
                          ...this.selectedItems,
                          {
                              type: item.type,
                              value: item.value,
                          },
                      ];
            }
        },
        searchChange() {},
        getFilteredItems() {
            const items = this.getItems();
            let q = (this.searchText || "").trim().toLowerCase();
            if (q.length === 0) return items;
            q = this.searchText.split(" ").join(".*");
            return items.filter((x) => new RegExp(q, "gi").test(x.name));
        },
    },
    watch: {
        value: {
            deep: true,
            handler(val) {
                if (_.isEqual(this.selectedItems, val)) return;
                this.selectedItems = _.cloneDeep(val || []);
            },
        },
        selectedItems: {
            deep: true,
            handler(val) {
                this.$emit("input", _.cloneDeep(val));
            },
        },
    },
});
</script>

<style scoped lang="scss">
.agent-picker {
    .pr-search {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 100%;

        input {
            border: 1px solid #c6cdd4 !important;
            width: 100%;
            padding: 10px;
            padding-right: 40px;
            border-radius: 5px;
            transition: all 0.3s;
        }

        input:focus {
            border: 1px solid black !important;
        }

        .pr-icon {
            position: absolute;
            right: 4px;
        }
    }

    .pr-items {
        min-height: 300px;
        max-height: 300px;
        overflow: auto;

        .pr-item:last-child {
            border-bottom: none;
        }

        .pr-item {
            display: flex;
            justify-content: start;
            align-items: center;
            flex-wrap: nowrap;
            padding: 5px 10px;
            border-radius: 4px;
            cursor: pointer;
            gap: 10px;
            border-bottom: 1px solid var(--color-border-default);

            &:hover {
                background: var(--color-bg-neutral-hover);
            }

            .user-data-wrapper {
                width: 100%;
                display: flex;
                justify-content: space-between;

                padding: 0 5px;

                .user-data {
                    display: flex;
                    gap: 5px;
                    align-items: center;

                    .avatar {
                        color: var(--color-text-onprimary-default);
                    }

                    .metas {
                        display: flex;
                        flex-direction: column;
                    }
                }
            }

            .pr-item-status {
                display: flex;
                justify-content: center;
                align-items: center;

                .pr-item-status-circle {
                    width: 10px;
                    height: 10px;
                    border-radius: 100%;
                    margin-right: 2px;
                }

                &[data-online="true"] {
                    &[data-status="online"] {
                        color: #1bc5bd !important;

                        .pr-item-status-circle {
                            background: #1bc5bd !important;
                        }
                    }

                    &[data-status="away"] {
                        color: #3699ff !important;

                        .pr-item-status-circle {
                            background: #3699ff !important;
                        }
                    }

                    &[data-status="busy"] {
                        color: #ffa829 !important;

                        .pr-item-status-circle {
                            background: #ffa829 !important;
                        }
                    }

                    &[data-status="offline"] {
                        color: #f64e60 !important;

                        .pr-item-status-circle {
                            background: #f64e60 !important;
                        }
                    }
                }

                &:not([data-online]) {
                    &[data-status="online"] {
                        color: var(--color-text-disabled);

                        .pr-item-status-circle {
                            background: var(--color-text-disabled) !important;
                        }
                    }

                    &[data-status="away"] {
                        color: var(--color-text-disabled);

                        .pr-item-status-circle {
                            background: var(--color-text-disabled) !important;
                        }
                    }

                    &[data-status="busy"] {
                        color: var(--color-text-disabled);

                        .pr-item-status-circle {
                            background: var(--color-text-disabled) !important;
                        }
                    }

                    &[data-status="offline"] {
                        color: var(--color-text-disabled);

                        .pr-item-status-circle {
                            background: var(--color-text-disabled) !important;
                        }
                    }
                }
            }
        }
    }
}
</style>
